import { startOfDay } from 'date-fns';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useUserDateTime } from '../../timezone/hooks/useUserDateTime';
import { TraceHistoryFilters } from '../types';

export const useGetFilterState = (key: number) => {
  const { getCurrentDateTime } = useUserDateTime();
  const initialTraceFilters: TraceHistoryFilters = {
    fromDate: startOfDay(new Date()),
    toDate: getCurrentDateTime(),
    analyzerId: -1,
    snapshotId: -1,
    savedAnalyzerId: -1,
    savedSnapshotId: -1,
  };

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm<TraceHistoryFilters>({
    defaultValues: initialTraceFilters,
  });

  // Refresh the toDate every time the component mounts
  useEffect(() => {
    reset({ ...initialTraceFilters, toDate: getCurrentDateTime() });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

  const saveAnalyzerAndSnapshotIds = () => {
    const form = getValues();
    setValue('savedAnalyzerId', form.analyzerId);
    setValue('savedSnapshotId', form.snapshotId);
  };

  return {
    control,
    watch,
    getValues,
    setValue,
    errors,
    handleSubmit,
    saveAnalyzerAndSnapshotIds,
  };
};
